function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006AB3",
  fillRule: "nonzero",
  d: "M24.388 4.167h-2.167V2h-1.444v2.167H9.222V2H7.777v2.167H5.612A3.616 3.616 0 0 0 2 7.778v16.61A3.616 3.616 0 0 0 5.612 28h18.776A3.616 3.616 0 0 0 28 24.389V7.777a3.616 3.616 0 0 0-3.612-3.61zm2.166 20.22a2.169 2.169 0 0 1-2.166 2.166H5.612a2.169 2.169 0 0 1-2.168-2.166V11.39h23.11v12.998zm0-14.443H3.444V7.777A2.17 2.17 0 0 1 5.612 5.61h2.167v1.444h1.443V5.611h11.555v1.445h1.444V5.61h2.167c1.194 0 2.166.971 2.166 2.166v2.167z"
});

var SvgChat = function SvgChat(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/chat.24524048.svg";
export { SvgChat as ReactComponent };